import React from 'react'
import GenerateHtml from '../generateHtml'

const Selonline = () => {
    return (
        <div>
            < GenerateHtml 
            reviewsColor= "#30a948"
            styles=" "
            displayingHtmlFor = "Selonline"
            />
        </div>
    )
}

export default Selonline
